/**
 * FAQPage type
 * DOC: https://schema.org/FAQPage
 */

export const faqPage = ({
  mainEntity,
  id
}) => {
  if (!mainEntity && (mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.length) <= 0) {
    throw new Error('mainEntity argument is required');
  }
  const questionItem = ({
    question,
    answer
  }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer
    }
  });
  const result = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': id,
    mainEntity: mainEntity.map(obj => questionItem(obj))
  };
  return JSON.stringify(result);
};